/**
 * Что показать человеку, когда сервер отказал.
 *
 * Наши отказы написаны словами и годятся как есть. Но не все отказы наши:
 * на ненайденный путь отвечает сам веб-каркас, и отвечает `Not Found` —
 * английским служебным словом, которое попадало в окно к человеку, читающему
 * экран по-немецки. Оно и по-английски ничего не объясняет: «не найдено» —
 * что именно?
 */

import { ApiError } from './api'
import type { Dict } from './i18n'

/** Тексты, которые пишет каркас, а не мы. */
const СЛУЖЕБНЫЕ = new Set([
  'Not Found',
  'Method Not Allowed',
  'Internal Server Error',
  'Unprocessable Entity',
  'Bad Gateway',
  'Service Unavailable',
])

export function readable(caught: unknown, t: Dict): string {
  if (!(caught instanceof ApiError)) return t.networkError
  // Ноль — это «не дошли до сервера»: сеть, а не отказ.
  if (caught.status === 0 || !caught.message.trim()) return t.networkError
  if (СЛУЖЕБНЫЕ.has(caught.message.trim())) return t.unclearError
  return caught.message
}
